import React, { useMemo, useState } from 'react';
import { navigate } from '@reach/router';
import { useMount } from 'ahooks';
import { apiHolder, apis, getIn18Text } from 'api';
import Button from '@lingxi-common-component/sirius-ui/Button';
import { popupIdSelector } from '@web-common/popup_state/selector';
import { useAppSelector } from '@web-common/state/createStore';
import PopupNotification from '@web-common/components/NotificationPopup/GlobalOrModule';
import styles from './style.module.scss';
const WIN_ID = 'NEWBIE_TASK_POPUP';
const taskCenterApi = apiHolder.api.requireLogicalApi(apis.taskCenterApiImpl);
const NewbieTaskPopup = () => {
    const [popupState, setPopupState] = useState('init');
    const winItem = useAppSelector(state => popupIdSelector(state.popupReducer, WIN_ID));
    const goNewbieTaskPage = () => {
        setPopupState('close');
        navigate('#noviceTask?page=noviceTask');
    };
    const isOversize7day = useMemo(() => {
        const lastCloseTime = (winItem === null || winItem === void 0 ? void 0 : winItem.lastCloseTime) || 0;
        if (lastCloseTime) {
            if (Date.now() - lastCloseTime > 7 * 24 * 60 * 60 * 1000) {
                return true;
            }
        }
        return false;
    }, []);
    useMount(() => {
        if (process.env.BUILD_ISEDM) {
            taskCenterApi.getNoviceTasks().then(({ totalCount, finishedCount }) => {
                setPopupState(finishedCount < totalCount ? 'show' : 'cancel');
            });
        }
    });
    if (!process.env.BUILD_ISEDM) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement(PopupNotification, { status: popupState, onClose: () => setPopupState('close'), winConfig: { id: WIN_ID, winType: 'WIN_FOR_NEW', renderType: 'custom', notShowPeriod: 7, forNew: true }, renderConfig: { className: styles.newbieTaskModal, footer: null, width: 520 } },
        React.createElement("div", { className: styles.content }, isOversize7day ? getIn18Text('JIXUWANCHENGXINSHOUREN') : getIn18Text('🎉 HUANYINGLAIDAO')),
        React.createElement("div", { className: styles.action },
            React.createElement(Button, { btnType: "primary", onClick: goNewbieTaskPage }, isOversize7day ? getIn18Text('JIXULEJIE') : getIn18Text('XIANZAIJIUQU')))));
};
export default NewbieTaskPopup;
